/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PalAuthSubmissionErrorType = {
    RemotePatientNotFound: 'REMOTE_PATIENT_NOT_FOUND',
    NoActiveCoverage: 'NO_ACTIVE_COVERAGE',
    InvalidMemberId: 'INVALID_MEMBER_ID',
    InvalidRequestingProviderNpi: 'INVALID_REQUESTING_PROVIDER_NPI',
    InvalidRequestingProviderTaxId: 'INVALID_REQUESTING_PROVIDER_TAX_ID',
    InvalidServicingProviderNpi: 'INVALID_SERVICING_PROVIDER_NPI',
    InvalidServicingFacilityNpi: 'INVALID_SERVICING_FACILITY_NPI',
    OrderingFacilityNotFound: 'ORDERING_FACILITY_NOT_FOUND',
    OrderingPhysicianNotFound: 'ORDERING_PHYSICIAN_NOT_FOUND',
    ServicingFacilityNotFound: 'SERVICING_FACILITY_NOT_FOUND',
    AttendingPhysicianNotFound: 'ATTENDING_PHYSICIAN_NOT_FOUND',
    PatientCurrentSettingUnknown: 'PATIENT_CURRENT_SETTING_UNKNOWN',
    InternalError: 'INTERNAL_ERROR',
    InvalidServicingFacilityTaxId: 'INVALID_SERVICING_FACILITY_TAX_ID',
    InvalidServicingProviderName: 'INVALID_SERVICING_PROVIDER_NAME',
    PatientNotManagedByProvider: 'PATIENT_NOT_MANAGED_BY_PROVIDER',
    PatientNotManagedByPortal: 'PATIENT_NOT_MANAGED_BY_PORTAL',
    PatientWithMultipleEncounters: 'PATIENT_WITH_MULTIPLE_ENCOUNTERS',
    DiagnosisCodeNotFound: 'DIAGNOSIS_CODE_NOT_FOUND',
    UnableToCommunicateWithPayer: 'UNABLE_TO_COMMUNICATE_WITH_PAYER',
    AuthPlatformUnavailable: 'AUTH_PLATFORM_UNAVAILABLE',
    MarkedAsErrorByPlatform: 'MARKED_AS_ERROR_BY_PLATFORM',
    WithdrawnByPlatform: 'WITHDRAWN_BY_PLATFORM',
    VoidedByPlatform: 'VOIDED_BY_PLATFORM'
} as const;
export type PalAuthSubmissionErrorType = typeof PalAuthSubmissionErrorType[keyof typeof PalAuthSubmissionErrorType];


export function PalAuthSubmissionErrorTypeFromJSON(json: any): PalAuthSubmissionErrorType {
    return PalAuthSubmissionErrorTypeFromJSONTyped(json, false);
}

export function PalAuthSubmissionErrorTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionErrorType {
    return json as PalAuthSubmissionErrorType;
}

export function PalAuthSubmissionErrorTypeToJSON(value?: PalAuthSubmissionErrorType | null): any {
    return value as any;
}

